// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e0a58e20","186":"97af4d79","225":"2a353e88","344":"b246bb2c","372":"a6707357","630":"5d22b7c6","841":"9b6e8aab","856":"52723134","858":"b3ae3bef"}[chunkId] + ".chunk.js";
};